export default {
  COORDINATORS: 'coordinators',
  COMMITTEE_MEMBERS: 'committeeMembers',
  ADMINISTRATORS: 'administrators'
};